import { Button, Form, InputNumber, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import I18n from "../../common/I18n";
import _ from "lodash";

const DriverDailySettlements = ({
    data=[],
    form,
	handleSave,
    status,
}) => {
    const [tableData, setTableData] = useState([])
	const [changedKeys, setChangedKeys] = useState([])
    const decimalPoints = window.localStorage.getItem('round_off_decimals');
	const [backUpValue, setBackUpValue] = useState([])

    useEffect(() => {
        setTableData([...data])
    }, [data]);

	const handleValueChange = (id, element, value) => {
		const records = [...tableData]
		const rowIndex = _.findIndex(records, { id: id });
		if (rowIndex >= 0) {
			if (!backUpValue.find(item => item.id === id)) {
				setBackUpValue(prev => [...prev, { id, value: records[rowIndex][element] }])
			}
			records[rowIndex][element] = value
			setTableData(records)
			setChangedKeys(prev => _.uniq([...prev, id]))
		}
	}

	const restoreBackupValue = (id) => {
		const records = [...tableData]
		const rowIndex = _.findIndex(records, { id: id });
		const backup = backUpValue.find(item => item.id === id);
		if (rowIndex >= 0 && backup) {
			records[rowIndex].item_value = backup.value
			setTableData(records)
			setChangedKeys(prev => prev.filter(key => key !== id))
			setBackUpValue(prev => prev.filter(item => item.id !== id))
		}
	}

	const onSave = () => {
		const changedRecords = tableData.filter(rec => changedKeys.includes(rec.id));
		handleSave(changedRecords, () => {
			setChangedKeys([])
			setBackUpValue([])
		}, restoreBackupValue)
	}

    const columns = [
		{
			title: "Charge",
			dataIndex: "item_charge",
			editable: false,
			width: 120,
			render: (data, record) => {
				return <span>{data}</span>
			}
		},
		{
			title: "Eligibility (%)",
			dataIndex: "eligible_percentage",
			editable: false,
            width: 120,
			render: (data, record) => {
				return <span>{data}</span>
			}
		},
        {
			title: `${I18n.t('reports.eligible')}* (${I18n.t('general.price_symbol')})`,
			dataIndex: "eligible_charge",
			editable: false,
            width: 140,
			render: (data, record) => {
				return <span>{data}</span>
			}
		},
        {
			title: `${I18n.t('reports.settlement')} %`,
			dataIndex: "settlement_percentage",
			editable: false,
            width: 140,
			render: (data, record) => {
				return <span>{data}</span>
			}
		},
        {
			title: `${I18n.t('reports.settlement')} (${I18n.t('general.price_symbol')})`,
			dataIndex: "item_value",
			editable: true,
            width: 140,
			render: (data, record, index) => {
				return (
                    <InputNumber
                        value={data}
                        size="small"
                        className="fontSize12"
                        placeholder={I18n.t('reports.settlement')}
                        // min={0}
                        precision={decimalPoints}
						onChange={(value) => handleValueChange(record.id, "item_value", value)}
                    />
                )
			}
		},
		{
			title: "Status",
			dataIndex: "status",
			editable: false,
			width: 120,
			render: (data, record) => {
				return <span>{status ? status : 'NA'}</span>
			}
		},
        {
			title: "Charge Type - Charge Description",
			dataIndex: "item_type",
			editable: false,
			render: (data, record) => {
                return <div>{record.item_type} - {record.item_name}</div>
			}
		},
		{
			title: "Description",
			dataIndex: "item_description",
			editable: false,
			render: (data, record) => {
				return <div>{record?.item_description || ""}</div>
			}
		},
    ]

    return(
        <Form form={form} component={false}>
			<Table
                dataSource={tableData}
				columns={columns}
				rowKey="id"
				rowClassName={(record) => record?.is_segregated_pay ? "driver-pay-highlight-row" : "editable-row"}
				pagination={false}
				bordered
			/>
			<Row className="alignRight" style={{ marginTop: "16px" }}>
				<Button
					type="primary"
					disabled={changedKeys.length < 1}
					onClick={(e) => onSave()}
				>Save</Button>
			</Row>
		</Form>
    )
}

const WrappedDailySettlements = Form.create()(DriverDailySettlements)

export default WrappedDailySettlements;